import TIMELINE_WORDINGS from './wording.js';
import ObjectList from 'vcomponents/utilities/ObjectList.vue';
import PersonLight from 'vcomponents/utilities/PersonLight.vue';

var TimelineWordingMixin = {
    methods: {
        getWording(wordingKey, subs) {
            const wording = TIMELINE_WORDINGS[wordingKey];

            if (!wording) {
                throw `The wording for ${wordingKey} does not exist`;
            }
            return wording(subs);
        },
        buildContent(log) {
            const params = {};
            Object.keys(log.params).forEach((key) => {
                if (
                    typeof log.params[key] === 'object' &&
                    log.params[key]['type'] === 'component'
                ) {
                    //build vue component for trad subs

                    let template = `<${log.params[key]['name']} :list="list" class="dinlineb" />`;
                    let list = log.params[key]['params']['list'];
                    let classes = 'mr-1';

                    if (log.params[key].name === 'person-list') {
                        template = `<PersonLight
                            :person="list"
                        />`;
                        list = log.params[key].params.list[0];
                        classes += ' cd-timeline-content--block';
                    }

                    const Component = Vue.extend({
                        components: {
                            PersonLight,
                            ObjectList,
                        },
                        data: () => {
                            return { list };
                        },
                        template,
                    });

                    const component = new Component().$mount();
                    params[key] = `<span class='${classes}'>${component.$el.outerHTML}</span>`;
                } else {
                    params[key] = `<span class='bold mr-1'>${log.params[key]}</span>`;
                }
            });
            //if we are not on the timeline of the object, we get translation who display the object name
            const wordingKey =
                log.objecttype !== this.linkedtype && TIMELINE_WORDINGS[log.action + '.linked']
                    ? log.action + '.linked'
                    : log.action;
            return this.getWording(wordingKey, params);
        },
    },
};

export default TimelineWordingMixin;
